import React from 'react';
const HomeIconAlt = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
      fill="none"
    />
    <path
      d="M21.5 24V15.4806C21.5 15.1768 21.3619 14.8895 21.1247 14.6998L14.6376 9.51008C14.2665 9.21322 13.7378 9.21851 13.3727 9.52273L8.35982 13.7002C8.13182 13.8901 8 14.1716 8 14.4684V24C8 24.5523 8.44772 25 9 25H20.5C21.0523 25 21.5 24.5523 21.5 24Z"
      fill="white"
    />
    <path
      d="M10 25H9C8.44772 25 8 24.5523 8 24V14.4538C8 14.1654 8.12448 13.8911 8.3415 13.7012L15.3415 7.57619C15.7185 7.24629 16.2815 7.24629 16.6585 7.57619L23.6585 13.7012C23.8755 13.8911 24 14.1654 24 14.4538V24C24 24.5523 23.5523 25 23 25H22"
      stroke="#A0A4C0"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13 19V25H19V19C19 17.8954 18.1046 17 17 17H15C13.8954 17 13 17.8954 13 19Z"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default HomeIconAlt;
